import { createContext } from 'react'

/** metadata for one selected leaf. absence from `rows` means unselected. */
export type CapabilityLeafRow = {
  yearsInBusiness: number
  inHouse: boolean
  subContracted: boolean
}

export type CapabilitiesFormState = {
  /** sparse, keyed by leaf key: only selected leaves are present. */
  rows: Record<string, CapabilityLeafRow>
  noneSelected: boolean
  /** ui-only, kept in reducer state so it survives re-renders. */
  query: string
  expandedCategories: Record<string, boolean>
  expandedGroups: Record<string, boolean>
  submitError: string | null
}

export type CapabilitiesFormAction =
  | { type: 'toggleLeaf'; leafKey: string }
  | { type: 'setYears'; leafKey: string; years: number }
  | {
      type: 'toggleSourcing'
      leafKey: string
      which: 'inHouse' | 'subContracted'
    }
  | {
      type: 'toggleGroupAll'
      groupKey: string
      leafKeys: string[]
      select: boolean
    }
  | { type: 'selectNone' }
  | { type: 'clearNone' }
  | { type: 'setQuery'; query: string }
  | { type: 'toggleCategory'; categoryKey: string }
  | { type: 'toggleGroup'; groupKey: string }
  | { type: 'setExpandedAll'; expand: boolean }
  | { type: 'submitError'; message: string | null }

export type CapabilitiesDerived = {
  selectedCount: number
  incompleteCount: number
  isValid: boolean
  countsByGroup: Record<string, number>
  countsByCategory: Record<string, number>
}

export type CapabilitiesFormContextValue = {
  state: CapabilitiesFormState
  derived: CapabilitiesDerived
  dispatch: React.Dispatch<CapabilitiesFormAction>
  isSubmitting: boolean
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void
}

export const CapabilitiesFormContext =
  createContext<CapabilitiesFormContextValue | null>(null)
